export default "__VITE_ASSET__Ctb9yp$9__"